
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvp-poc-development",
      function () {
        return require("private-next-pages/mvp-poc-development.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvp-poc-development"])
      });
    }
  